import { render, staticRenderFns } from "./answerRec.vue?vue&type=template&id=fef1f074&scoped=true&"
import script from "./answerRec.vue?vue&type=script&lang=js&"
export * from "./answerRec.vue?vue&type=script&lang=js&"
import style0 from "./answerRec.vue?vue&type=style&index=0&id=fef1f074&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef1f074",
  null
  
)

export default component.exports